import React from 'react';

/**
 * CheckboxField - Boolean checkbox field
 *
 * @param {Object} props
 * @param {Object} props.field - Field configuration
 * @param {string} props.field.key - Unique field identifier
 * @param {string} props.field.label - Display label
 * @param {string} [props.field.description] - Additional description text
 * @param {boolean} [props.field.default] - Default value
 * @param {boolean} props.value - Current value
 * @param {Function} props.onChange - Callback when value changes
 * @param {boolean} [props.disabled] - Whether field is disabled
 */
export default function CheckboxField({ field, value, onChange, disabled = false }) {
  const handleChange = (e) => {
    onChange(e.target.checked);
  };

  const isChecked = value ?? field.default ?? false;

  return (
    <label className={`flex items-start cursor-pointer ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}>
      <input
        type="checkbox"
        checked={isChecked}
        onChange={handleChange}
        disabled={disabled}
        className="mt-0.5 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
      />
      <div className="ml-2">
        <span className="text-xs font-medium text-gray-700">{field.label}</span>
        {field.description && (
          <p className="text-xs text-gray-500">{field.description}</p>
        )}
      </div>
    </label>
  );
}
